export const ADD_COMPANY_EMPLOYEE_LOADING = 'ADD_COMPANY_EMPLOYEE_LOADING';

export const ADD_COMPANY_EMPLOYEE_ERROR = 'ADD_COMPANY_EMPLOYEE_ERROR';

export const INITIATE_ADD_COMPANY_EMPLOYEE_APPLICATION_SUCCESS = 'INITIATE_ADD_COMPANY_EMPLOYEE_APPLICATION_SUCCESS';

export const CLEAR_ADD_COMPANY_EMPLOYEE_APPLICATION_ERROR = 'CLEAR_ADD_COMPANY_EMPLOYEE_APPLICATION_ERROR';

export const FETCH_APPLICATION_ADD_COMPANY_EMPLOYEE_SUCCESS = 'FETCH_APPLICATION_ADD_COMPANY_EMPLOYEE_SUCCESS';

export const FETCH_DOCUMENTS_ADD_COMPANY_EMPLOYEE_SUCCESS = 'FETCH_DOCUMENTS_ADD_COMPANY_EMPLOYEE_SUCCESS';

export const ADD_COMPANY_EMPLOYEE_CLEAR_DATA = 'ADD_COMPANY_EMPLOYEE_CLEAR_DATA';

export const DOWNLOAD_DOCUMENT_ADD_COMPANY_EMPLOYEE_SUCCESS = 'DOWNLOAD_DOCUMENT_ADD_COMPANY_EMPLOYEE_SUCCESS';

export const ADD_COMPANY_EMPLOYEE_CANCEL_APPLICATION_SUCCESS = 'ADD_COMPANY_EMPLOYEE_CANCEL_APPLICATION_SUCCESS';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';

export const CHANGE_ADD_COMPANY_EMPLOYEE_STEP = 'CHANGE_ADD_COMPANY_EMPLOYEE_STEP';

export const FETCH_EMPLOYEE_PERMISSIONS_SUCCESS = 'FETCH_EMPLOYEE_PERMISSIONS_SUCCESS';

export const UPDATE_INFO_FORM_FIELD = 'UPDATE_INFO_FORM_FIELD';

export const FETCH_EMPLOYEE_USER_SUCCESS = 'FETCH_EMPLOYEE_USER_SUCCESS';

export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS';

export const UPDATE_FETCHED_USER_INFO = 'UPDATE_FETCHED_USER_INFO';

export const UPDATE_SELECTED_PERMISSION = 'UPDATE_SELECTED_PERMISSION';

export const UPLOAD_ADD_COMPANY_EMPLOYEE_DOCUMENT_SUCCESS = 'UPLOAD_ADD_COMPANY_EMPLOYEE_DOCUMENT_SUCCESS';

export const SAVE_APPLICATION_ADD_COMPANY_EMPLOYEE_SUCCESS = 'SAVE_APPLICATION_ADD_COMPANY_EMPLOYEE_SUCCESS';

export const UPDATE_ADDED_EMPLOYEE_INFORMATION = 'UPDATE_ADDED_EMPLOYEE_INFORMATION';

export const CHECK_IS_ADMIN = 'CHECK_IS_ADMIN';
